var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3667 4C8.30498 4 6.63333 5.67005 6.63333 7.73125C6.63333 9.79244 8.30498 11.4625 10.3667 11.4625C12.4284 11.4625 14.1 9.79244 14.1 7.73125C14.1 5.67005 12.4284 4 10.3667 4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3 9.33333V11.4667H15.1667V12.5333H17.3V14.6667H18.3667V12.5333H20.5V11.4667H18.3667V9.33333H17.3Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.5937L8.23333 13.5937C6.17159 13.5937 4.5 15.2646 4.5 17.3265V19.9903L16.2333 19.9903V17.3265C16.2333 15.2646 14.5617 13.5937 12.5 13.5937Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUserIcon);
export default __webpack_public_path__ + "static/media/addUserIcon.c4182cc4556dea5a5f6fc51305cbc47a.svg";
export { ForwardRef as ReactComponent };